/**
 * Helpers drawn with the scene (debug collision meshes, the editor's visuals, UI panels) never
 * cast or receive shadows: every render component under `root` is switched off for both.
 */
import * as pc from 'playcanvas';

export function disableHelperShadows(root: pc.Entity): void {
    for (const render of root.findComponents('render') as pc.RenderComponent[]) {
        render.castShadows = false;
        render.receiveShadows = false;
    }
}
